"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataChunk = exports.DataChunkTags = exports.DataChunkContent = void 0;
const zod_1 = require("zod");
const base64_string_1 = require("./base64-string");
exports.DataChunkContent = base64_string_1.Base64String;
exports.DataChunkTags = zod_1.z.record(zod_1.z.string(), zod_1.z.string());
exports.DataChunk = zod_1.z.object({
    content: exports.DataChunkContent,
    tags: exports.DataChunkTags,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS1jaHVuay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kYXRhLWNodW5rLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUF1QjtBQUV2QixtREFBOEM7QUFFakMsUUFBQSxnQkFBZ0IsR0FBRyw0QkFBWSxDQUFBO0FBRy9CLFFBQUEsYUFBYSxHQUFHLE9BQUMsQ0FBQyxNQUFNLENBQUMsT0FBQyxDQUFDLE1BQU0sRUFBRSxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFBO0FBR2hELFFBQUEsU0FBUyxHQUFHLE9BQUMsQ0FBQyxNQUFNLENBQUM7SUFDaEMsT0FBTyxFQUFFLHdCQUFnQjtJQUN6QixJQUFJLEVBQUUscUJBQWE7Q0FDcEIsQ0FBQyxDQUFBIn0=